module.exports = __webpack_public_path__ + "static/media/icon-192x192.1b88489f.png";